import { FaMicrochip } from "react-icons/fa";

import containerStyles from "../pages/Container.module.css";
import styles from "./Footer.module.css";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={`container ${containerStyles.cscontainer}`}>
                <div className="row g-5">
                    <div className="col-12 col-lg-5">
                        <div className={styles.footerBrand}>
                            <div className={styles.footerBrandIcon}>
                                <FaMicrochip />
                            </div>
                            <div>
                                <strong>IVEC 2027</strong>
                                <span>
                                    International Vacuum
                                    Electronics Conference
                                </span>
                            </div>
                        </div>

                        <p>
                            A global forum dedicated to advancing
                            vacuum electronics through research,
                            innovation, collaboration and knowledge
                            exchange.
                        </p>
                    </div>

                    <div className="col-6 col-md-6 col-lg-3">
                        <h4>Conference</h4>
                        <button>About IVEC</button>
                        <button>Programme</button>
                        <button>Important Dates</button>
                        <button>Venue</button>
                    </div>

                    <div className="col-6 col-md-6 col-lg-4">
                        <h4>Quick Access</h4>
                        <button>Author Resources</button>
                        <button>Registration</button>
                        <button>Sponsors & Exhibitors</button>
                        <button>Visa Help</button>
                        <button>Awards</button>
                    </div>
                </div>

                <div className={styles.footerBottom}>
                    <span>
                        © 2027 International Vacuum Electronics
                        Conference (IVEC)
                    </span>
                    <span>
                        Organized by VEDAS • Technical
                        Co-Sponsorship by IEEE EDS
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;